module.exports = __webpack_public_path__ + "static/img/YM@2x.3c4b059a.jpg";